import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { EditProfile } from './pages/EditProfile';
import { Profile } from './pages/Profile';

export const ProfileRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.PROFILE} component={Profile} />
      <Route path={ROUTES.EDIT_PROFILE} component={EditProfile} />
    </Switch>
  );
}

export default ProfileRoutes;
